// import React, { useState, useMemo, useEffect } from "react";
// import updown from "../../Assets/Images/CommanImages/updown.png";
// import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
// import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";
// import Colors from "../../Constants/Colors";

// const SelectedStudentTable = ({
//   headers = [],
//   data = [],
//   searchPlaceholder = "Search...",
// }) => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: "asc",
//   });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [isSearchOpen, setIsSearchOpen] = useState(true);

//   useEffect(() => {
//     setVisibleColumns(headers);
//   }, [headers]);

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const filteredData = useMemo(() => {
//     return data.filter((row) =>
//       row.some(
//         (cell) =>
//           cell &&
//           String(cell)
//             .toLowerCase()
//             .includes(searchQuery.toLowerCase())
//       )
//     );
//   }, [data, searchQuery]);

//   const handleSort = (column) => {
//     let direction = "asc";

//     if (
//       sortConfig.key === column &&
//       sortConfig.direction === "asc"
//     ) {
//       direction = "desc";
//     }

//     setSortConfig({
//       key: column,
//       direction,
//     });
//   };

//   const sortedData = useMemo(() => {
//     let sortableData = [...filteredData];

//     if (sortConfig.key) {
//       const colIndex = headers.indexOf(sortConfig.key);

//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }

//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }

//         return 0;
//       });
//     }

//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const totalPages = Math.ceil(
//     sortedData.length / pageSize
//   );

//   const paginatedData = useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;

//     return sortedData.slice(
//       startIndex,
//       startIndex + pageSize
//     );
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];

//     for (let i = 1; i <= totalPages; i++) {
//       pages.push(
//         <button
//           key={i}
//           onClick={() => setCurrentPage(i)}
//           className={i === currentPage ? "active" : ""}
//           style={{ borderRadius: "5px" }}
//         >
//           {i}
//         </button>
//       );
//     }

//     return pages;
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "0px 0px 4px 11px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//           }}
//         >
//           {isSearchOpen && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 border: `1px solid ${Colors.color4}`,
//                 overflow: "hidden",
//                 backgroundColor: "transparent",
//                 width: "476px",
//               }}
//             >
//               <input
//                 type="text"
//                 placeholder={searchPlaceholder}
//                 name="search"
//                 className="search-input-ques-dash"
//                 onChange={handleSearch}
//               />
//               <img
//                 src={searchicon}
//                 alt="search"
//                 style={{
//                   backgroundColor: `${Colors.color14}`,
//                   marginBottom: "3px",
//                   padding: "4px 2px 2px 2px",
//                 }}
//                 className="search-icon-ques-dash"
//               />
//             </div>
//           )}
//         </div>

//         <div style={{ color: "#424242" }}>
//           Displaying{" "}
//           {Math.min(
//             (currentPage - 1) * pageSize + 1,
//             sortedData.length
//           )}
//           -
//           {Math.min(
//             currentPage * pageSize,
//             sortedData.length
//           )}{" "}
//           of {sortedData.length} records |
//           {["10", "25", "50", "100"].map((size) => (
//             <span
//               key={size}
//               onClick={() => {
//                 setPageSize(Number(size));
//                 setCurrentPage(1);
//               }}
//               style={{
//                 cursor: "pointer",
//                 margin: "0 5px",
//                 textDecoration:
//                   pageSize === Number(size)
//                     ? "none"
//                     : "underline",
//                 color:
//                   pageSize === Number(size)
//                     ? "black"
//                     : "#337AB7",
//               }}
//             >
//               {size}
//             </span>
//           ))}
//         </div>
//       </div>

//       <div className="table-wrapper-cols-selections">
//         <table
//           className="table-tc"
//           style={{
//             width: "100%",
//             tableLayout: "auto",
//           }}
//         >
//           <thead>
//             <tr>
//               {visibleColumns.map((heading, index) => (
//                 <td
//                   key={index}
//                   className="Heading-tc"
//                   style={{
//                     backgroundColor: "#fff1d1",
//                     padding: "12px 10px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "8px",
//                     }}
//                   >
//                     {heading}

//                     <img
//                       src={updown}
//                       alt="sort"
//                       style={{
//                         width: "16px",
//                         height: "16px",
//                       }}
//                       onClick={() =>
//                         handleSort(heading)
//                       }
//                     />
//                   </div>
//                 </td>
//               ))}
//             </tr>
//           </thead>

//           <tbody>
//             {paginatedData.map((row, rowIndex) => (
//               <tr
//                 key={rowIndex}
//                 className={
//                   rowIndex % 2 === 1
//                     ? "even-row-tc"
//                     : ""
//                 }
//               >
//                 {row.map((cell, cellIndex) => (
//                   <td
//                     key={cellIndex}
//                     style={{
//                       padding: "12px 10px",
//                       color: "#6A6A6A",
//                       textAlign: "left",
//                       whiteSpace: "normal",
//                       overflowWrap: "break-word",
//                     }}
//                   >
//                     {cell ?? "---"}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div
//         className="pagination-tc"
//         style={{ marginTop: "10px" }}
//       >
//         <button
//           onClick={() => setCurrentPage(1)}
//           disabled={currentPage === 1}
//           className="extreme-left-tc-pagination"
//         >
//           <img src={leftArrow} alt="" />
//         </button>

//         <button
//           onClick={() =>
//             setCurrentPage((prev) =>
//               Math.max(prev - 1, 1)
//             )
//           }
//           disabled={currentPage === 1}
//           className="lefttc-pagination"
//         >
//           {"<"}
//         </button>

//         {renderPagination()}

//         <button
//           onClick={() =>
//             setCurrentPage((prev) =>
//               Math.min(prev + 1, totalPages)
//             )
//           }
//           disabled={currentPage === totalPages}
//           className="righttc-pagination"
//         >
//           {">"}
//         </button>

//         <button
//           onClick={() => setCurrentPage(totalPages)}
//           disabled={currentPage === totalPages}
//           className="extreme-right-tc-pagination"
//         >
//           <img src={rightArrow} alt="" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SelectedStudentTable;

import React, { useState, useMemo, useEffect } from "react";
import updown from "../../Assets/Images/CommanImages/updown.png";
import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";
import femaleImg from "../../Assets/Images/Landing/female_01.png";
import maleImg from "../../Assets/Images/Landing/male_01.png";
import Colors from "../../Constants/Colors";
import { FULL_API_BASE_URL } from "../../Config/Config";

const SelectedStudentTable = ({
  headers: externalHeaders = [],
  data: externalData = [],
  searchPlaceholder = "Search...",
  batchId,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [internalHeaders, setInternalHeaders] = useState([]);
  const [internalData, setInternalData] = useState([]);

  const headers = batchId ? internalHeaders : externalHeaders;
  const data = batchId ? internalData : externalData;

  useEffect(() => {
    if (!batchId) return;
    const fetchBatchStudents = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-student-list-by-batch-id/?batch_id=${batchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const result = await response.json();
        if (result.status === 200 && result.data) {
          setInternalHeaders([
            "Photo",
            "Roll Number",
            "Student Name",
            "Gender",
            "Student Type",
            "Mentor",
            "Status",
            "Gender ID",
            "Student ID",
          ]);
          const mapped = result.data.map((s) => [
            s.photograph_url,
            s.roll_number,
            s.student_full_name,
            s.gender_name,
            s.student_type,
            s.mentor_name,
            s.status,
            s.gender_id,
            s.student_id,
          ]);
          setInternalData(mapped);
        }
      } catch (error) {
        console.error("Error fetching batch students:", error);
      }
    };
    fetchBatchStudents();
  }, [batchId]);

  const hiddenColumns = ["Gender ID", "Student ID"];
  const visibleColumns = headers.filter((h) => !hiddenColumns.includes(h));

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredData = useMemo(() => {
    return data.filter((row) =>
      row.some(
        (cell) =>
          cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [data, searchQuery]);

  const sortedData = useMemo(() => {
    let sortable = [...filteredData];
    if (sortConfig.key) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortable.sort((a, b) => {
        if (a[colIndex] < b[colIndex])
          return sortConfig.direction === "asc" ? -1 : 1;
        if (a[colIndex] > b[colIndex])
          return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortable;
  }, [filteredData, sortConfig, headers]);

  const totalPages = Math.ceil(sortedData.length / pageSize);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const handleSort = (column) => {
    setSortConfig((prev) => ({
      key: column,
      direction:
        prev.key === column && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getGenderAvatar = (row) => {
    const genderIdIndex = headers.indexOf("Gender ID");
    const genderId = row[genderIdIndex];
    return genderId === 1 ? maleImg : femaleImg;
  };

  const renderPagination = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={i === currentPage ? "active" : ""}
          style={{ borderRadius: "5px" }}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <div>
      {/* ── Hover zoom style ── */}
      <style>{`
        .photo-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          cursor: pointer;
        }
        .photo-avatar:hover {
          transform: scale(2.2);
          box-shadow: 0 4px 16px rgba(0,0,0,0.25);
          z-index: 10;
          position: relative;
        }
      `}</style>

      {/* ── Toolbar: search + record count ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px 0px 4px 11px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: `1px solid ${Colors.color4}`,
              overflow: "hidden",
              backgroundColor: "transparent",
              width: "476px",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <img
              src={searchicon}
              alt="search"
              style={{
                backgroundColor: `${Colors.color14}`,
                marginBottom: "3px",
                padding: "4px 2px 2px 2px",
              }}
              className="search-icon-ques-dash"
            />
          </div>
        </div>

        <div style={{ color: "#424242" }}>
          Displaying{" "}
          {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)}-
          {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
          {sortedData.length} records |{" "}
          {["10", "25", "50", "100"].map((size) => (
            <span
              key={size}
              onClick={() => {
                setPageSize(Number(size));
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                margin: "0 5px",
                textDecoration:
                  pageSize === Number(size) ? "none" : "underline",
                color: pageSize === Number(size) ? "black" : "#337AB7",
              }}
            >
              {size}
            </span>
          ))}
        </div>
      </div>

      {/* ── Table ── */}
      <div className="table-wrapper-cols-selections">
        <table
          className="table-tc"
          style={{ width: "100%", tableLayout: "auto" }}
        >
          <thead>
            <tr>
              {visibleColumns.map((heading, index) => (
                <td
                  key={index}
                  className="Heading-tc"
                  style={{
                    backgroundColor: "#fff1d1",
                    padding: "12px 10px",
                    cursor: "pointer",
                    width: heading === "Photo" ? "80px" : "auto",
                    textAlign: heading === "Photo" ? "center" : "left",
                  }}
                >
                  {heading === "Photo" ? null : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {heading}
                      <img
                        src={updown}
                        alt="sort"
                        style={{ width: "16px", height: "16px" }}
                        onClick={() => handleSort(heading)}
                      />
                    </div>
                  )}
                </td>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
              >
                {visibleColumns.map((column, colIdx) => {
                  const cellIndex = headers.indexOf(column);
                  const cellValue = row[cellIndex];

                  // ── Photo cell ──
                  if (column === "Photo") {
                    const isValidUrl =
                      cellValue &&
                      cellValue !== "---" &&
                      (cellValue.startsWith("http://") ||
                        cellValue.startsWith("https://"));

                    return (
                      <td
                        key={colIdx}
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          padding: "6px 8px 6px 20px", // ✅ left margin
                          width: "80px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            const studentIdIndex =
                              headers.indexOf("Student ID");
                            const studentId = row[studentIdIndex];
                            window.open(
                              `/student_dashboard?studentId=${studentId}`,
                              "_blank"
                            );
                          }}
                          title="View student dashboard"
                        >
                          {isValidUrl ? (
                            <>
                              <img
                                src={cellValue}
                                alt="Student"
                                className="photo-avatar" // ✅ zoom on hover
                                style={{
                                  objectFit: "contain",
                                  objectPosition: "top center",
                                  background: "#f5f5f5",
                                }}
                                onError={(e) => {
                                  e.currentTarget.style.display = "none";
                                  e.currentTarget.nextSibling.style.display =
                                    "block";
                                }}
                              />
                              <img
                                src={getGenderAvatar(row)}
                                alt="Avatar"
                                className="photo-avatar" // ✅ zoom on hover
                                style={{
                                  display: "none",
                                  objectFit: "cover",
                                }}
                              />
                            </>
                          ) : (
                            <img
                              src={getGenderAvatar(row)}
                              alt="Avatar"
                              className="photo-avatar" // ✅ zoom on hover
                              style={{ objectFit: "cover" }}
                            />
                          )}
                        </div>
                      </td>
                    );
                  }

                  // ── All other cells ──
                  return (
                    <td
                      key={colIdx}
                      style={{
                        padding: "12px 10px",
                        color: "#6A6A6A",
                        textAlign: "left",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                      }}
                    >
                      {cellValue ?? "---"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Pagination ── */}
      <div className="pagination-tc" style={{ marginTop: "10px" }}>
        <button
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
          className="extreme-left-tc-pagination"
        >
          <img src={leftArrow} alt="" />
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="lefttc-pagination"
        >
          {"<"}
        </button>
        {renderPagination()}
        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="righttc-pagination"
        >
          {">"}
        </button>
        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
          className="extreme-right-tc-pagination"
        >
          <img src={rightArrow} alt="" />
        </button>
      </div>
    </div>
  );
};

export default SelectedStudentTable;
